/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Prover.Gamification API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface ApiErrorResponse
 */
export interface ApiErrorResponse {
    /**
     * 
     * @type {Error}
     * @memberof ApiErrorResponse
     */
    error?: Error;
}

/**
 * 
 * @export
 * @interface ApiResponseCommitResultOutput
 */
export interface ApiResponseCommitResultOutput {
    /**
     * 
     * @type {CommitResultOutput}
     * @memberof ApiResponseCommitResultOutput
     */
    data?: CommitResultOutput;
}

/**
 * 
 * @export
 * @interface ApiResponseGameResult
 */
export interface ApiResponseGameResult {
    /**
     * 
     * @type {GameResult}
     * @memberof ApiResponseGameResult
     */
    data?: GameResult;
}

/**
 * 
 * @export
 * @interface ApiResponseListTopResultOutput
 */
export interface ApiResponseListTopResultOutput {
    /**
     * 
     * @type {Array<TopResultOutput>}
     * @memberof ApiResponseListTopResultOutput
     */
    data?: Array<TopResultOutput>;
}

/**
 * 
 * @export
 * @interface CommitResultInput
 */
export interface CommitResultInput {
    /**
     * Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
     * @type {string}
     * @memberof CommitResultInput
     */
    gameType: string;
    /**
     * 
     * @type {string}
     * @memberof CommitResultInput
     */
    time: string;
    /**
     * 
     * @type {number}
     * @memberof CommitResultInput
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitResultInput
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitResultInput
     */
    longitude?: number;
}

/**
 * 
 * @export
 * @interface CommitResultOutput
 */
export interface CommitResultOutput {
    /**
     * 
     * @type {GameResultOutput}
     * @memberof CommitResultOutput
     */
    current?: GameResultOutput;
    /**
     * 
     * @type {GameResultOutput}
     * @memberof CommitResultOutput
     */
    best?: GameResultOutput;
    /**
     * 
     * @type {string}
     * @memberof CommitResultOutput
     */
    userMaskedEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitResultOutput
     */
    userCode?: string;
}

/**
 * 
 * @export
 * @interface GameResult
 */
export interface GameResult {
    /**
     * 
     * @type {string}
     * @memberof GameResult
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GameResult
     */
    gameType?: string;
    /**
     * 
     * @type {string}
     * @memberof GameResult
     */
    time?: string;
    /**
     * 
     * @type {number}
     * @memberof GameResult
     */
    score?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameResult
     */
    usersBestResult?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GameResult
     */
    userId?: number;
    /**
     * 
     * @type {User}
     * @memberof GameResult
     */
    user?: User;
    /**
     * 
     * @type {number}
     * @memberof GameResult
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof GameResult
     */
    created?: Date;
}

/**
 * 
 * @export
 * @interface GameResultOutput
 */
export interface GameResultOutput {
    /**
     * 
     * @type {number}
     * @memberof GameResultOutput
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof GameResultOutput
     */
    created?: Date;
    /**
     * 
     * @type {number}
     * @memberof GameResultOutput
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof GameResultOutput
     */
    time?: string;
    /**
     * Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
     * @type {string}
     * @memberof GameResultOutput
     */
    gameType?: string;
    /**
     * 
     * @type {string}
     * @memberof GameResultOutput
     */
    countryCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GameResultOutput
     */
    placeInWorld?: number;
    /**
     * 
     * @type {number}
     * @memberof GameResultOutput
     */
    placeInCountry?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameResultOutput
     */
    usersBestResult?: boolean;
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    locationType?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ModelError
     */
    errors?: Array<Error>;
}

/**
 * 
 * @export
 * @interface TopResultOutput
 */
export interface TopResultOutput {
    /**
     * 
     * @type {Date}
     * @memberof TopResultOutput
     */
    created?: Date;
    /**
     * 
     * @type {number}
     * @memberof TopResultOutput
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof TopResultOutput
     */
    time?: string;
    /**
     * 
     * @type {number}
     * @memberof TopResultOutput
     */
    place?: number;
    /**
     * 
     * @type {string}
     * @memberof TopResultOutput
     */
    maskedEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TopResultOutput
     */
    userCode?: string;
}

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    maskedEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    code?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    updated?: Date;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    created?: Date;
}


/**
 * CheckApi - fetch parameter creator
 * @export
 */
export const CheckApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(options: any = {}): FetchArgs {
            const localVarPath = `/check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckApi - functional programming interface
 * @export
 */
export const CheckApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CheckApiFetchParamCreator(configuration).check(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CheckApi - factory interface
 * @export
 */
export const CheckApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(options?: any) {
            return CheckApiFp(configuration).check(options)(fetch, basePath);
        },
    };
};

/**
 * CheckApi - object-oriented interface
 * @export
 * @class CheckApi
 * @extends {BaseAPI}
 */
export class CheckApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckApi
     */
    public check(options?: any) {
        return CheckApiFp(this.configuration).check(options)(this.fetch, this.basePath);
    }

}

/**
 * MainApi - fetch parameter creator
 * @export
 */
export const MainApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommitResultInput} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitResult(input?: CommitResultInput, options: any = {}): FetchArgs {
            const localVarPath = `/CommitResult`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CommitResultInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(input || {}) : (input || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestResult(gameType: string, options: any = {}): FetchArgs {
            // verify required parameter 'gameType' is not null or undefined
            if (gameType === null || gameType === undefined) {
                throw new RequiredError('gameType','Required parameter gameType was null or undefined when calling getBestResult.');
            }
            const localVarPath = `/GetBestResult`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (gameType !== undefined) {
                localVarQueryParameter['GameType'] = gameType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {number} [count] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTop(gameType: string, count?: number, countryCode?: string, options: any = {}): FetchArgs {
            // verify required parameter 'gameType' is not null or undefined
            if (gameType === null || gameType === undefined) {
                throw new RequiredError('gameType','Required parameter gameType was null or undefined when calling getTop.');
            }
            const localVarPath = `/GetTop`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['Count'] = count;
            }

            if (gameType !== undefined) {
                localVarQueryParameter['GameType'] = gameType;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['CountryCode'] = countryCode;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MainApi - functional programming interface
 * @export
 */
export const MainApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommitResultInput} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitResult(input?: CommitResultInput, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApiResponseCommitResultOutput> {
            const localVarFetchArgs = MainApiFetchParamCreator(configuration).commitResult(input, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestResult(gameType: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApiResponseGameResult> {
            const localVarFetchArgs = MainApiFetchParamCreator(configuration).getBestResult(gameType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {number} [count] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTop(gameType: string, count?: number, countryCode?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApiResponseListTopResultOutput> {
            const localVarFetchArgs = MainApiFetchParamCreator(configuration).getTop(gameType, count, countryCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MainApi - factory interface
 * @export
 */
export const MainApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CommitResultInput} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitResult(input?: CommitResultInput, options?: any) {
            return MainApiFp(configuration).commitResult(input, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestResult(gameType: string, options?: any) {
            return MainApiFp(configuration).getBestResult(gameType, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
         * @param {number} [count] 
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTop(gameType: string, count?: number, countryCode?: string, options?: any) {
            return MainApiFp(configuration).getTop(gameType, count, countryCode, options)(fetch, basePath);
        },
    };
};

/**
 * MainApi - object-oriented interface
 * @export
 * @class MainApi
 * @extends {BaseAPI}
 */
export class MainApi extends BaseAPI {
    /**
     * 
     * @param {CommitResultInput} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public commitResult(input?: CommitResultInput, options?: any) {
        return MainApiFp(this.configuration).commitResult(input, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public getBestResult(gameType: string, options?: any) {
        return MainApiFp(this.configuration).getBestResult(gameType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} gameType Possible values are: FixLengthSwype, InfiniteLengthSwype, InfiniteLengthSwypeIncreasingDifficulty
     * @param {number} [count] 
     * @param {string} [countryCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainApi
     */
    public getTop(gameType: string, count?: number, countryCode?: string, options?: any) {
        return MainApiFp(this.configuration).getTop(gameType, count, countryCode, options)(this.fetch, this.basePath);
    }

}

